import {Injectable} from '@angular/core';
import {Observable} from "rxjs/Observable";
import {HttpCacheClient} from "../http/http-cache-client";

@Injectable()
export class ValueLists {

    /**
     * ValueListsService Constructor.
     */
    constructor(private httpClient: HttpCacheClient) {}

    /**
     * Get value list by name.
     */
    public get(name: string): Observable<{currencies: any}> {
        return this.httpClient.getWithCache('value-lists/'+name);
    }

    /**
     * Fetch all existing app permissions.
     */
    public getPermissions(): Observable<{permissions: object}> {
        return this.httpClient.getWithCache('value-lists/permissions');
    }

    public getValuesForSelects() {
        return this.httpClient.getWithCache('value-lists/selects');
    }
}


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/node_modules/vebto-client/core/services/value-lists.service.ts